import { useMemo } from 'react';

import { useConfiguration } from '@ocx/data-configuration';

import { AnalyticsInstance } from './rudder-stack.types';
import { getRudderStackInstance } from './rudder-stack.utils';

export const useRudderStack = (): AnalyticsInstance => {
  const {
    config: {
      rudderStack: { enabled },
    },
  } = useConfiguration();

  return useMemo(() => {
    return getRudderStackInstance(enabled);
  }, [enabled]);
};
